import { Team__Nogaleras } from "./teams/Nogaleras";
import { Team__NogalerasJR } from "./teams/NogalerasJR";
import { Team__Panthers } from "./teams/Panthers";
import { Team__Raptors } from "./teams/Raptors";

export const teamList_old_fem = [
  Team__Nogaleras,
  Team__NogalerasJR,
  Team__Panthers,
  Team__Raptors,
];
